/**
 * Trainer self-signup page → admin approval queue.
 */
import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api.js";

export default function Signup() {
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", display_name: "" });
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null); setBusy(true);
    try {
      await api("/api/auth/signup", { method: "POST", body: form, noAuth: true });
      setDone(true);
    } catch (err: any) {
      const code = err?.body?.error;
      setError(
        code === "email_taken"   ? "此 email 已註冊"
        : code === "weak_password" ? "密碼至少 8 個字元"
        : err?.message ?? "註冊失敗"
      );
    } finally { setBusy(false); }
  }

  if (done) {
    return (
      <main className="page page--auth">
        <div className="serial" style={{ marginBottom: "var(--s-3)" }}>申請已送出</div>
        <h1 style={{ fontSize: "var(--t-2xl)", marginBottom: "var(--s-3)" }}>
          等候<span className="italic-display" style={{ color: "var(--rust)" }}>管理員審核</span>
        </h1>
        <p className="muted" style={{ fontSize: "var(--t-sm)", lineHeight: 1.6 }}>
          通過後會以 email 通知，再回來登入即可。
        </p>
        <Link to="/login" className="btn btn--ghost" style={{ marginTop: "var(--s-5)" }}>
          回登入頁
        </Link>
      </main>
    );
  }

  return (
    <main className="page page--auth">
      <div className="rise rise-1" style={{ marginBottom: "var(--s-7)" }}>
        <div className="serial" style={{ marginBottom: "var(--s-3)" }}>Trainer signup</div>
        <h1 style={{ fontSize: "var(--t-2xl)" }}>申請<span className="italic-display" style={{ color: "var(--rust)" }}>訓練師</span>帳號</h1>
        <p className="muted" style={{ fontSize: "var(--t-sm)", marginTop: "var(--s-3)", lineHeight: 1.6 }}>
          需經管理員審核。資料給管理員辨識身分用，不會公開。
        </p>
      </div>

      <form onSubmit={onSubmit} className="rise rise-2">
        <div className="col" style={{ gap: "var(--s-4)" }}>
          <div className="field">
            <label className="field-label">姓名 / 暱稱</label>
            <input required value={form.display_name}
                   onChange={e => setForm({ ...form, display_name: e.target.value })} />
          </div>
          <div className="field">
            <label className="field-label">Email</label>
            <input type="email" required value={form.email}
                   onChange={e => setForm({ ...form, email: e.target.value })} />
          </div>
          <div className="field">
            <label className="field-label">密碼 (≥ 8 字)</label>
            <input type="password" required minLength={8} value={form.password}
                   onChange={e => setForm({ ...form, password: e.target.value })} />
          </div>

          {error && <div className="alert">{error}</div>}

          <button type="submit" className="btn btn--rust" disabled={busy} style={{ justifyContent: "center" }}>
            {busy ? "送出中…" : "送出申請 →"}
          </button>
        </div>
      </form>

      <p className="rise rise-3 muted" style={{ marginTop: "var(--s-6)", fontSize: "var(--t-sm)" }}>
        已有帳號？<Link to="/login">回登入</Link>
      </p>
    </main>
  );
}
